import { useLayoutEffect } from "react";

import { cssZoomOf } from "./siteScale";

/**
 * Publishes the rendered height of `.la-pinned-header` as the CSS custom
 * property `--la-header-h` on the root element (#2408). On a phone the nav
 * wraps to three rows, so a fixed scroll margin lands hash targets under it.
 * The stylesheets read `max(96px, calc(var(--la-header-h, 0px) + 16px))`.
 */
export function useHeaderOffset(): void {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const header = document.querySelector<HTMLElement>(".la-pinned-header");
    if (!header) return;
    const publish = () => {
      // The rect is in screen px; the value is read back inside the page
      // root, which may carry the laptop zoom (#2817), so divide it out.
      const h = Math.ceil(header.getBoundingClientRect().height / cssZoomOf(header));
      if (h > 0) root.style.setProperty("--la-header-h", `${h}px`);
    };
    publish();
    const observer =
      typeof ResizeObserver === "undefined" ? undefined : new ResizeObserver(publish);
    observer?.observe(header);
    return () => {
      observer?.disconnect();
      root.style.removeProperty("--la-header-h");
    };
  }, []);
}
